import React from 'react'
import TextField from '@material-ui/core/TextField'
import t from 'tcomb-form'
import moment from 'moment'

const renderDate = locals => {
  const currentTime = !!locals.value ? moment(locals.value) : moment()
  return (
    <TextField
      disabled={!!locals.disabled}
      id='datetime-local'
      label=''
      type='datetime-local'
      value={currentTime.format('YYYY-MM-DDTHH:mm')}
      InputLabelProps={{
        shrink: true
      }}
      onChange={event => {
        locals.onChange(moment(event.target.value).valueOf())
      }}
    />
  )
}

const datePickerTemplate = t.form.Form.templates.date.clone({ renderDate })

class DatePickerFactory extends t.form.Component {
  getTemplate() {
    return datePickerTemplate
  }
}

export default DatePickerFactory



// WEBPACK FOOTER //
// ./src/containers/formTemplate/datepickerfactory.tsx